import {PageSlot} from "mfront";

export default function PublicLayout() {
    return (
        <>
            <div>
                <PageSlot/>
            </div>
        </>
    )
}